// Module
var code = "<select class=\"form-control input-sm\" ng-model=\"vm.model\" ng-options=\"level.key as level.value | translate for level in vm.currentLevels\" ng-change=\"vm.onChange()\"> </select>";
// Exports
module.exports = code;